import { render } from "./ProductManage.vue?vue&type=template&id=690547d8"
import script from "./ProductManage.vue?vue&type=script&lang=js"
export * from "./ProductManage.vue?vue&type=script&lang=js"

import "./ProductManage.vue?vue&type=style&index=0&id=690547d8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__